export const state = () => ({
  disableVA: false,
  countdown: '',
  auth: {
    userData: null,
    token: null,
    whatsappNumber: null
  },
  user: {
    drugs: [],
    phone: null,
    register: null,
    email: ''
  }
})

export const mutations = {
  SET_DISABLE_VA: (state, data) => {
    state.disableVA = data
  },
  SET_COUNTDOWN_LEFT: (state, data) => {
    state.countdown = data
  },
  SET_USER_TOKEN: (state, token) => {
    state.auth.token = token
  },
  SET_USER_DATA: (state, data) => {
    state.auth.userData = data
  },
  SET_USER_WHATSAPP: (state, data) => {
    state.auth.whatsappNumber = data
  },
  SET_USER_DRUGS: (state, data) => {
    state.user.drugs = data
  },
  SET_USER_REGISTER: (state, data) => {
    state.user.register = data
  },
  SET_USER_PHONE: (state, data) => {
    state.user.phone = data
  },
  SET_USER_EMAIL: (state, data) => {
    state.user.email = data
  }
}

export const actions = {
  auth ({ commit }, token) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + 'me/profile', {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + token
        }
      })
        .then(function (response) {
          const res = response.data
          commit('SET_USER_TOKEN', token)
          commit('SET_USER_DATA', res.Data)

          if (res.Data) {
            commit('SET_USER_WHATSAPP', res.Data.WhatsappNumber)
          }
          resolve(res)
        })
        .catch(function (error) {
          const err = error.response.data
          reject(err)
        })
    })
  },
  getPaymentList ({ commit, state, rootState }) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + `patient/payment/appointment?ID=${rootState.doctor.appointmentBook.ID}`, {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + state.auth.token
        }
      })
        .then(function (response) {
          const res = response.data.Data
          if (response.data.Data.VirtualAccount) {
            commit('SET_COUNTDOWN_LEFT', response.data.Data.VirtualAccount.CountDownLeft)
          }
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  acceptTnc ({ commit, state }) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'patient/accept/tnc', '', {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + state.auth.token
        }
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          const err = error.response.data
          reject(err)
        })
    })
  },
  saveBooking ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      const { AppointmentOnlineID, PatientID, FacilityID, FacilityType } = data

      const formDataBooking = new FormData()
      formDataBooking.append('AppointmentOnlineID', AppointmentOnlineID)
      formDataBooking.append('PatientID', PatientID)

      if (FacilityID && FacilityType) {
        formDataBooking.append('FacilityID', FacilityID)
        formDataBooking.append('FacilityType', FacilityType)
      }

      this.$axios.post(process.env.BASE_API + 'calendar/appointment/book', formDataBooking, {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + state.auth.token
        }
      }).then(function (response) {
        const res = response.data.Data
        resolve(res)
      }).catch(function (error) {
        const err = error.response.data
        reject(err)
      })
    })
  },
  searchDrugs ({ commit }, query) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_YD_URL + '/ajax/drugs.php?q=' + query, {
        headers: {
          WebVersion: '1'
        }
      })
        .then(function (response) {
          const res = response.data
          commit('SET_USER_DRUGS', true)
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  submitRegister ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formDataRegister = new FormData()

      formDataRegister.append('Type', data.Type)
      formDataRegister.append('TypeResponse', data.TypeResponse)
      formDataRegister.append('TypeID', data.TypeID)
      formDataRegister.append('Firstname', data.Firstname)
      formDataRegister.append('Lastname', data.Lastname)
      formDataRegister.append('Password', data.Password)
      formDataRegister.append('Email', data.Email)
      formDataRegister.append('Phone', data.Phone)
      formDataRegister.append('Gender', data.Gender)
      formDataRegister.append('Birthdate', data.Birthdate)
      formDataRegister.append('Nationality', data.Nationality)
      formDataRegister.append('Language', data.Language)
      formDataRegister.append('Alergi', data.Alergi)
      formDataRegister.append('ObatRutin', JSON.stringify(data.ObatRutin))
      formDataRegister.append('ReferralCode', data.ReferralCode)
      formDataRegister.append('BloodType', data.BloodType)
      formDataRegister.append('Height', data.Height)
      formDataRegister.append('Weight', data.Weight)

      this.$axios.post(process.env.BASE_API_V2 + 'Register', formDataRegister, {
        headers: {
          WebVersion: '3'
        }
      })
        .then(function (response) {
          const res = response.data

          commit('SET_USER_REGISTER', res)
          commit('SET_USER_PHONE', data.Phone)
          commit('SET_USER_EMAIL', data.Email)
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  updateRegister ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      const formDataUpdateRegister = new FormData()

      formDataUpdateRegister.append('Email', data.Email)
      formDataUpdateRegister.append('Firstname', data.Firstname)
      formDataUpdateRegister.append('Lastname', data.Lastname)
      formDataUpdateRegister.append('Gender', data.Gender)
      formDataUpdateRegister.append('Birthdate', data.Birthdate)
      formDataUpdateRegister.append('BloodType', data.BloodType)
      formDataUpdateRegister.append('Height', data.Height)
      formDataUpdateRegister.append('Weight', data.Weight)

      this.$axios.post(process.env.BASE_API_V2 + 'Me/EditProfile', formDataUpdateRegister, {
        headers: {
          WebVersion: '3',
          Authorization: 'Bearer ' + state.auth.token
        }
      })
        .then(function (response) {
          const res = response.data

          commit('SET_USER_REGISTER', res)
          commit('SET_USER_PHONE', data.Phone)
          commit('SET_USER_EMAIL', data.Email)
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  checkPhoneResend ({ commit }, token) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + 'check/phone/resend', {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + token
        }
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          const err = error.response.data
          reject(err)
        })
    })
  },
  PhoneVerification ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formDataLogin = new FormData()
      formDataLogin.append('Code', data.Password)

      this.$axios.post(process.env.BASE_API + 'phone/verification', formDataLogin, {
        headers: {
          WebVersion: '3',
          AUTHORIZATION: 'Bearer ' + data.Token
        }
      })
        .then(function (response) {
          const res = response.data

          commit('SET_USER_REGISTER', res)
          resolve(res)
        })
        .catch(function (error) {
          reject(error.response)
        })
    })
  },
  askSchedule ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + `${data.Token ? '' : 'public/'}calendar/doctor/request/` + data.DoctorPublicID, null, {
        headers: {
          WebVersion: '3',
          Authorization: 'Bearer ' + data.Token
        }
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          const err = error.response.data
          reject(err)
        })
    })
  },
  getDetailPayment ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + 'patient/global/transaction/detail/' + data.OrderID)
        .then(function (response) {
          const res = response && response.data
          resolve(res)
        })
        .catch(function (error) {
          const err = error.response.data
          reject(err)
        })
    })
  },
  getMyAppointments ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + 'patient/my/appointments', {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + data
        }
      })
        .then(function (response) {
          const res = response && response.data
          resolve(res)
        })
        .catch(function (error) {
          const err = error.response.data
          reject(err)
        })
    })
  }
}
